module.exports = __webpack_public_path__ + "media/images/download/price_doc-461bd22df1007310045154a2cffe536b.png";